import productsActionTypes from "./productsActionTypes";

export const getProducts = () => ({
  type: productsActionTypes.GET_ALL_PRODUCTS_START,
});

export const getProductSuccess = (products) => ({
  type: productsActionTypes.GET_ALL_PRODUCTS_SUCCESS,
  payload: products,
});

export const getProductsFailed = (error) => ({
  type: productsActionTypes.GET_ALL_PRODUCTS_FAILED,
  payload: error,
});

export const getProductsGroups = (request) => ({
  type: productsActionTypes.GET_PRODUCT_GROUPS_START,
  payload: request,
});

export const getProductsGroupSuccess = (groups) => ({
  type: productsActionTypes.GET_PRODUCT_GROUPS_SUCCESS,
  payload: groups,
});

export const getProductsGroupFailed = (error) => ({
  type: productsActionTypes.GET_PRODUCT_GROUPS_FAILED,
  payload: error,
});

export const getProductsCategory = (request) => ({
  type: productsActionTypes.GET_PRODUCT_CATEGORY_START,
  payload: request,
});

export const getProductsCategorySuccess = (categories) => ({
  type: productsActionTypes.GET_PRODUCT_CATEGORY_SUCCESS,
  payload: categories,
});

export const getProductsCategoryFailed = (error) => ({
  type: productsActionTypes.GET_PRODUCT_CATEGORY_FAILED,
  payload: error,
});

export const getBrandsStart = (request) => ({
  type: productsActionTypes.GET_BRANDS_START,
  payload: request,
});

export const getBrandsSuccess = (brands) => ({
  type: productsActionTypes.GET_BRANDS_SUCCESS,
  payload: brands,
});

export const getBrandsFailed = (error) => ({
  type: productsActionTypes.GET_BRANDS_FAILED,
  payload: error,
});

export const getSuppliersStart = (request) => ({
  type: productsActionTypes.GET_SUPPLIERS_START,
  payload: request,
});

export const getSuppliersSuccess = (suppliers) => ({
  type: productsActionTypes.GET_SUPPLIERS_SUCCESS,
  payload: suppliers,
});

export const getSuppliersFailed = (error) => ({
  type: productsActionTypes.GET_SUPPLIERS_FAILED,
  payload: error,
});

export const getTotalCount = (request) => ({
  type: productsActionTypes.GET_PRODUCT_TOTAL_COUNT_START,
  payload: request,
});

export const getProductGroupTotal = (request) => ({
  type: productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_START,
  payload: request,
});

export const getAssortments = (request) => ({
  type: productsActionTypes.GET_ASSORTMENTS_START,
  payload: request,
});

export const getVatRates = (request) => ({
  type: productsActionTypes.GET_VAT_RATES_START,
  payload: request,
});

export const getPriorityGroup = (request) => ({
  type: productsActionTypes.GET_PRIORITY_GROUP_START,
  payload: request,
});

export const getProductCountries = (request) => ({
  type: productsActionTypes.GET_PRODUCT_COUNTRY_START,
  payload: request,
});

export const getCompanyTypes = (request) => ({
  type: productsActionTypes.GET_COMPANY_TYPES_START,
  payload: request,
});

export const getCurrencies = (request) => ({
  type: productsActionTypes.GET_CURRENCIES_START,
  payload: request,
});

export const getSupplierTypes = (request) => ({
  type: productsActionTypes.GET_SUPPLIER_TYPES_START,
  payload: request,
});

export const getIndentedGroups = (request) => ({
  type: productsActionTypes.GET_INDENTED_GROUPS_START,
  payload: request,
});

export const getIndentedCategories = (request) => ({
  type: productsActionTypes.GET_INDENTED_CATEGORY_START,
  payload: request,
});
